import type { JSX } from "react";
import { Alert, AlertDescription } from "@/ui/alert.js";

export interface DuplicateNoteProps {
  title: string;
}

/**
 * Shared amber "Already in your library" note shown wherever a
 * duplicate-import check finds a match (AddRecipeSheet, ShareTarget,
 * NewImport). Renders the title as plain text — never
 * `dangerouslySetInnerHTML` (LLM-derived text stays plain per project
 * convention).
 */
export function DuplicateNote({ title }: DuplicateNoteProps): JSX.Element {
  return (
    <Alert className="border-amber-600/60 bg-amber-950/40 text-amber-100">
      <AlertDescription className="text-amber-200">
        Already in your library:{" "}
        <span className="font-medium text-amber-100">{title}</span>
      </AlertDescription>
    </Alert>
  );
}
